<template>
    <b-modal id="webSettingsModal" hide-backdrop centered :no-close-on-esc="true" v-bind:title="webSettingsTitle"
            ok-title="Update" @ok="updateSettings" :ok-disabled="okButtonDisabled" @hidden="editModal" @cancel="editModal" @shown="updateWebSettings(tenant)">
            <b-form ref="form">
  
              <!--            <b-form-group> -->
              <!--              <label class="checkbox-container">-->
              <!--                Do not store temperature alert images-->
              <!--                <input-->
              <!--                  type="checkbox"-->
              <!--                  :value="doNotStoreImage"-->
              <!--                  id="doNotStoreImages"-->
              <!--                  v-model="doNotStoreImages"-->
              <!--                />-->
              <!--                <span class="checkmark"></span>-->
              <!--              </label>-->
              <!--            </b-form-group>-->
  
              <div class="modal-body-container">
                <b-card class="card-container-panel">
                  <b-card-title>Tenant Settings</b-card-title>
                  <b-form-group>
                    <label class="checkbox-container">
                      Use only Tenant Specific Roles (Roles at the root level will not
                      display)
                      <input type="checkbox" :value="useTenantSpecificRoles" id="useTenantSpecificRoles"
                        v-model="useTenantSpecificRoles" @input="markAsChanged('useTenantSpecificRoles')" />
                      <span class="checkmark"></span>
                    </label>
                  </b-form-group>
  
                  <b-form-group>
                    <label class="checkbox-container">
                      Disable Noise Suppression
                      <input type="checkbox" :value="disableNoiseSuppression" id="disableNoiseSuppression"
                        v-model="disableNoiseSuppression" @input="markAsChanged('disableNoiseSuppression')" />
                      <span class="checkmark"></span>
                    </label>
                  </b-form-group>
  
                  
                  <b-form-group>
                    <label class="custom-form-label">Custom help message</label>
                    <b-form-input id="customHelpMessage" class="custom-form-group-help-message valid"
                      placeHolder="Custom help message" type="text" required @input="markAsChanged('customHelpmessage')"
                      v-model="customHelpmessage" ></b-form-input>
  
                  </b-form-group>
                </b-card>
                <b-card title="Virtual care" class="card-container-panel">
                  <b-form-group>
                    <label class="checkbox-container">
                      Disable Virtual Care Chime
                      <input type="checkbox" :value="disableVirtualNursingChime" id="disableVirtualNursingChime"
                        v-model="disableVirtualNursingChime" @input="markAsChanged('disableVirtualNursingChime')" />
                      <span class="checkmark"></span>
                    </label>
                  </b-form-group>
                  <b-form-group>
                    <label class="custom-form-label">Patient Name Format</label>
                    <b-form-select v-model="patientNameFormatSelectedOption" :options="patientNameFormatOptions"
                      id="patientNameFormat" @input="markAsChanged('patientNameFormat')"></b-form-select>
                  </b-form-group>
  
                </b-card>
                <b-card title="Virtual Monitoring" class="card-container-panel">
                  <b-form-group>
                    <label class="checkbox-container">
                      Disable push-to-talk 
                      <input type="checkbox" :value="disablePTT" id="disablePTT"
                      v-model="disablePTT" @input="markAsChanged('disablePTT')"/>
                      <span class="checkmark"></span>
                    </label>
                  </b-form-group>
                  <b-form-group>
                   <label class="checkbox-container">
                      Prevent push-to-talk Suppress Speaker
                      <input type="checkbox" :value="preventPTTSS" id="preventPTTSS"
                      :disabled="disablePTT"
                      v-model="preventPTTSS" @input="markAsChanged('preventPTTSS')"/>
                      <span class="checkmark"></span>
                    </label>
                  </b-form-group>
                  <b-form-group>
                    <label class="custom-form-label">Keep Alive Session Time</label>
                    <b-form-input type="number" @input="validateNumericInput(); markAsChanged('vm_popupInterval')" min="60"
                      id="vm_popupInterval" v-model="vm_popupInterval"
                      :class="(vm_popupInterval !== null && !isNumeric(vm_popupInterval)) || (vm_popupInterval !== null && isNumeric(vm_popupInterval) && vm_popupInterval < 60) ? 'in-valid' : 'valid'"></b-form-input>
                    <p v-if="vm_popupInterval !== null && !isNumeric(vm_popupInterval)" style="color: red">Please enter a
                      valid
                      numeric value.</p>
                    <p v-if="vm_popupInterval !== null && isNumeric(vm_popupInterval) && vm_popupInterval < 60"
                      style="color: red">Interval shuld be grater then 60 mins.</p>
                  </b-form-group>
                  <!-- vm_popupCheckInterval -->
                  <b-form-group>
                    <label class="custom-form-label">Session Logout Time</label>
                    <b-form-input type="number" @input="validateNumericInput(); markAsChanged('vm_popupCheckInterval')"
                      min="15" id="vm_popupCheckInterval" v-model="vm_popupCheckInterval"
                      :class="(vm_popupCheckInterval !== null && !isNumeric(vm_popupCheckInterval)) || (vm_popupCheckInterval !== null && isNumeric(vm_popupCheckInterval) && vm_popupCheckInterval < 15) ? 'in-valid' : 'valid'"></b-form-input>
                    <p v-if="vm_popupCheckInterval !== null && !isNumeric(vm_popupCheckInterval)" style="color: red">Please
                      enter a valid
                      numeric value.</p>
                    <p v-if="vm_popupCheckInterval !== null && isNumeric(vm_popupCheckInterval) && vm_popupCheckInterval < 15"
                      style="color: red">Interval shuld be grater then 15 mins.</p>
                  </b-form-group>
                  <!-- endCallTimeout -->
                  <b-form-group>
                    <label class="custom-form-label">End Call Timeout (Secs)</label>
                    <b-form-input type="number" @input="validateNumericInput(); markAsChanged('endCallTimeout')" min="15"
                      id="endCallTimeout" v-model="endCallTimeout"
                      :class="(endCallTimeout !== null && !isNumeric(endCallTimeout)) || (endCallTimeout !== null && isNumeric(endCallTimeout) && endCallTimeout < 40) ? 'in-valid' : 'valid'"></b-form-input>
                    <p v-if="endCallTimeout !== null && !isNumeric(endCallTimeout)" style="color: red">Please enter a valid
                      numeric value.</p>
                    <p v-if="endCallTimeout !== null && isNumeric(endCallTimeout) && endCallTimeout < 40"
                      style="color: red">Timeout shuld be grater then 40 secs.</p>
                  </b-form-group>
                  <b-form-group>
                    <label class="custom-form-label">Choose Virtual Monitoring Max View Mode</label>
                    <b-form-select v-model="vm_maxViewMode" :options="maxViewMode" id="vm_maxViewMode"
                      @input="markAsChanged('vm_maxViewMode')"></b-form-select>
                  </b-form-group>
  
                </b-card>
                <p v-if="webConfigurationErrorMessage !== ''" class="errorMsgContainer">{{
                webConfigurationErrorMessage }}</p>
              </div>
  
  
              <!-- patientNameFormat -->
  
  
  
              <!-- vm_maxViewMode -->
  
  
              <!-- for configuration  -->
              <!--  <b-form-group label="Custom High Temp Status" label-for="tempStatus">
              <b-form-input id="tempStatus" v-model="tempStatus"></b-form-input>
              </b-form-group>-->
              <!--  <b-form-group label="Qr_code_expiry" label-for="qr_code_expiry">
              <b-form-input id="qr_code_expiry" v-model="qr_code_expiry"></b-form-input>
              </b-form-group>-->
              <div class="permissionContentWrapper">
                <div class="contentData row m-0 align-items-center col-12 p-0" v-for="(item, index) in items"
                  v-bind:key="item">
                  <div class="col">
                    {{
                      permissions.find((p) => p.value == item)
                      ? permissions.find((p) => p.value == item).text
                      : ""
                    }}
                  </div>
                  <div class="col actionHeading text-center">
                    <img v-on:click="removePermission(index)" src="../../assets/images/remove.svg" width="16" />
                  </div>
                </div>
              </div>
  
            </b-form>
          </b-modal>
</template>
<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
Vue.use(VueToast);
export default{
  name:"WebSettingsAction",
    data(){
        return{
            lastTenant:"",
            webSettingsTitle:"",
            doNotStoreImages:false,
            hasQuestionnarieTempleteExists:false,
            disableVirtualNursingChime:false,
            enableSchedule:false,
            employeeIdNotUnique:false,
            customHelpmessage:"",
            disablePTT:false,
            preventPTTSS:false,
            useTenantSpecificRoles:false,
            patientNameFormatSelectedOption:false,
            vm_maxViewMode:false,
            vm_popupInterval: 60,
            vm_popupCheckInterval: 15,
            hideAllFacilities: false,
            enableTimerInEntranceActivity:false,
            disableNoiseSuppression:false,
            endCallTimeout: 40,
            okButtonDisabled: false,
            changedWebSettingsControls: {},
            webConfigurationErrorMessage: "",
            items:[],
            patientNameFormatOptions: [
            {value: "LNF", text: "Last Name First"},
            {value: "FNF", text: "First Name First"}],
            maxViewMode: [
        {
          text: "One Column",
          value: "1col"
        },
        {
          text: "Two Columns",
          value: "2cols"
        },
        {
          text: "External",
          value: "external"
        },
        {
          text: "Disabled",
          value: "disabled"
        },

      ],

            


        }
    },
    props:['tenant','tenants'],
    watch: {
      disablePTT(newVal) {
        if (newVal) {
          this.preventPTTSS = true;
          this.markAsChanged('preventPTTSS'); 
        }
      }
    },
    methods:{
      async createTenantScheduling(tenant) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url =
            config.COVID_SURVEY + `/createTenantScheduling?tenants=${tenant}`;
        var tenantScheduling = new Request(url, {
          method: "POST",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var tenantSchedulingResponse = await fetch(tenantScheduling);
          if (tenantSchedulingResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (tenantSchedulingResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (tenantSchedulingResponse.status == 503) {
            return this.createTenantScheduling(tenant);
          }
          if (tenantSchedulingResponse.status != 200) {
            this.commandError = "Failed to send email for onboarding";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            var sendTempleteBody = await tenantSchedulingResponse.json();
            Vue.$toast.open({
              message: "Tenant Scheduling created",
              type: "info",
              duration: 3000,
              position: "bottom",
            });
          }
        } catch (tex) {
          this.commandError =
              "Failed to " + command.command + " due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
      },
      async createQuestionnaireAddress(tenant) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url =
            config.COVID_SURVEY + `/createQuestionnaireAddress?tenants=${tenant}`;
        var tenantScheduling = new Request(url, {
          method: "POST",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var questionnaireAddressResponse = await fetch(questionnaireAddress);
  
          if (questionnaireAddressResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (questionnaireAddressResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (questionnaireAddressResponse.status == 503) {
            return this.createQuestionnaireAddress(tenant);
          }
          if (questionnaireAddressResponse.status != 200) {
            this.commandError = "Failed to send email for onboarding";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            var sendTempleteBody = await questionnaireAddressResponse.json();
            Vue.$toast.open({
              message: "Created Questionnaire Address",
              type: "info",
              duration: 3000,
              position: "bottom",
            });
          }
        } catch (tex) {
          this.commandError =
              "Failed to " + command.command + " due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
      },
      async createQuestionnaire(tenant) {
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url =
            config.COVID_SURVEY + `/createQuestionnaireTemplete?tenants=${tenant}`;
        var sendQuestionnaireTemplete = new Request(url, {
          method: "POST",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var sendQuestionnaireTempleteResponse = await fetch(
              sendQuestionnaireTemplete
          );
          if (sendQuestionnaireTempleteResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (sendQuestionnaireTempleteResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (sendQuestionnaireTempleteResponse.status == 500) {
            this.commandError = "Questionnarie Templete already exist";
            Vue.$toast.open({message: this.commandError, type: "error"});
            return;
          }
          if (sendQuestionnaireTempleteResponse.status == 503) {
            return this.createQuestionnaire(tenant);
          }
          if (sendQuestionnaireTempleteResponse.status != 200) {
            this.commandError = "Failed to create questionnaries";
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            var sendTempleteBody = await sendQuestionnaireTempleteResponse.json();
            Vue.$toast.open({
              message: "Questionnaire Templete created",
              type: "info",
              duration: 3000,
              position: "bottom",
            });
          }
        } catch (tex) {
          this.commandError =
              "Failed to " + command.command + " due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
      },
      markAsChanged(controlName) {
        this.$set(this.changedWebSettingsControls, controlName, true);
    },
      async updateSettings(command, args, when) {
      if (
          this.hasQuestionnarieTempleteExists == false &&
          this.hasQuestionnarieTemplete == true
      ) {
        this.createQuestionnaire(this.lastTenant);
      }
      if (this.hasQuestionnarieAddress == true) {
        this.createQuestionnaireAddress(this.lastTenant);
      }
      if (this.enableSchedule == true) {
        this.createTenantScheduling(this.lastTenant);
      }

      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
          config.TENET_SERVICE + `/tenants/${this.lastTenant}/updateWebSettings`;

      var tenants_settings_request = new Request(url, {
        method: "PATCH",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          doNotStoreImages: this.doNotStoreImages,
          otherWebSettings: this.updateSelectedOtherWebSettingsChanges(),
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var tenantSettingsResponse = await fetch(tenants_settings_request);
        if (tenantSettingsResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";
          Vue.$toast.open({message: this.errorMessage, type: "error"});

          return;
        }
        if (tenantSettingsResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          Vue.$toast.open({message: this.errorMessage, type: "error"});
          return;
        }
        if (tenantSettingsResponse.status == 503) {
          return this.updateSettings(command, args, when);
        }
        if (tenantSettingsResponse.status != 200) {
          (this.errorMessage = "Error occurred to "),
              command.command,
              " :",
              tenantSettingsResponse.status;

          this.commandError = "Failed to update " + this.webSettingsTitle;
          Vue.$toast.open({message: this.commandError, type: "error"});
        } else {
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "hasQuestionnarieTemplete"
              ] = this.hasQuestionnarieTemplete;
          this.tenants.find((x) => x.name === this.lastTenant)[
              "isPrivacyEnabled"
              ] = this.doNotStoreImages;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "hasQuestionnarieAddress"
              ] = this.hasQuestionnarieAddress;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "enableSchedule"
              ] = this.enableSchedule;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "employeeIdNotUnique"
              ] = this.employeeIdNotUnique;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "enableCSVDownload"
              ] = this.editCSVDownload;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "entranceActivityRefreshRateInSeconds"
              ] = this.refreshRateInSeconds;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "punchInDataAvailable"
              ] = this.punchInData;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "lowTemperatureCutoff"
              ] = this.temperatureCutoff;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "useTenantSpecificRoles"
              ] = this.useTenantSpecificRoles;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "disablePTT"
              ] = this.disablePTT;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "preventPTTSS"
              ] = this.preventPTTSS;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "customHelpMessage"
              ] = this.customHelpmessage;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "disableNoiseSuppression"
              ] = this.disableNoiseSuppression;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "disableVirtualNursingChime"
              ] = this.disableVirtualNursingChime;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "patientNameFormat"
              ] = this.patientNameFormatSelectedOption;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "vm_popupInterval"
              ] = this.vm_popupInterval * 60000;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "vm_popupCheckInterval"
              ] = this.vm_popupCheckInterval * 60000;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "hideAllFacilities"
              ] = this.hideAllFacilities;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "enableTimerInEntranceActivity"] =
              this.enableTimerInEntranceActivity;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "endCallTimeout"] =
              this.endCallTimeout * 1000;
          this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
              "vm_maxViewMode"] =
              this.vm_maxViewMode;
          var tenantsBody = await tenantSettingsResponse.json();
          this.commandError = "";
          this.changedWebSettingsControls = {};
          Vue.$toast.open({
            message: "Successfully Updated " + this.webSettingsTitle,
            type: "success",
          });
        }
      } catch (tex) {
        this.commandError = "Failed! due to an error.";
        Vue.$toast.open({message: this.commandError, type: "error"});
      }
      //  this.fetchData();
    },
      async updateWebSettings(tenant) {
      this.lastTenant = tenant.name;
      this.webSettingsTitle = "IDA Web Settings - " + tenant.name;
      this.doNotStoreImages = tenant.isPrivacyEnabled
        ? tenant.isPrivacyEnabled
        : false;

      this.hasQuestionnarieTempleteExists =
        tenant &&
          tenant.webSettings &&
          tenant.webSettings.hasQuestionnarieTemplete
          ? tenant.webSettings.hasQuestionnarieTemplete
          : false;

      this.enableSchedule =
        tenant && tenant.webSettings && tenant.webSettings.enableSchedule
          ? tenant.webSettings.enableSchedule
          : false;
      this.employeeIdNotUnique =
        tenant && tenant.webSettings && tenant.webSettings.employeeIdNotUnique
          ? tenant.webSettings.employeeIdNotUnique
          : false;



      this.customHelpmessage = tenant &&
        tenant.webSettings &&
        tenant.webSettings.customHelpMessage
        ? tenant.webSettings.customHelpMessage
        : "";
      this.disablePTT = tenant && tenant.webSettings && tenant.webSettings.disablePTT ? tenant.webSettings.disablePTT: false;
      this.preventPTTSS = tenant &&
        tenant.webSettings &&
        tenant.webSettings.preventPTTSS
        ? tenant.webSettings.preventPTTSS
        : false;


      this.useTenantSpecificRoles =
        tenant &&
          tenant.webSettings &&
          tenant.webSettings.useTenantSpecificRoles
          ? tenant.webSettings.useTenantSpecificRoles
          : false;
      //new fields added are from here 2507 tickets--starts here 
      this.patientNameFormatSelectedOption = tenant && tenant.webSettings && tenant.webSettings.patientNameFormat ? tenant.webSettings.patientNameFormat : "FNF";
      this.vm_maxViewMode = tenant && tenant.webSettings && tenant.webSettings.vm_maxViewMode ? tenant.webSettings.vm_maxViewMode
        : '1col';

      this.vm_popupInterval = tenant && tenant.webSettings && tenant.webSettings.vm_popupInterval ? tenant.webSettings.vm_popupInterval / 60000
        : 60;

      this.vm_popupCheckInterval = tenant && tenant.webSettings && tenant.webSettings.vm_popupCheckInterval ? tenant.webSettings.vm_popupCheckInterval / 60000
        : 15;

      this.hideAllFacilities = tenant && tenant.webSettings && tenant.webSettings.hideAllFacilities ? tenant.webSettings.hideAllFacilities
        : false;

      this.enableTimerInEntranceActivity = tenant && tenant.webSettings && tenant.webSettings.enableTimerInEntranceActivity ? tenant.webSettings.enableTimerInEntranceActivity
        : false;

      this.disableNoiseSuppression = tenant && tenant.webSettings && tenant.webSettings.disableNoiseSuppression ? tenant.webSettings.disableNoiseSuppression
        : false;

      this.disableVirtualNursingChime = tenant && tenant.webSettings && tenant.webSettings.disableVirtualNursingChime ? tenant.webSettings.disableVirtualNursingChime
        : false;

      this.endCallTimeout = tenant && tenant.webSettings && tenant.webSettings.endCallTimeout ? tenant.webSettings.endCallTimeout / 1000
        : 40;

      //new fields added are from here 2507 tickets--ends here 


    },
    isNumeric(value) {
        return /^[+-]?\d+(\.\d+)?$/.test(value);
      },
      isConditionSatisfiedWeb() {
      //checking the error validations for numbers fields //if need to add more fields we need to check here object based approch is not suits for this form
      if (this.isNumeric(this.vm_popupInterval) && this.isNumeric(this.endCallTimeout) && this.isNumeric(this.vm_popupCheckInterval) && (this.vm_popupCheckInterval >= 15) && (this.endCallTimeout >= 40) && (this.vm_popupInterval >= 60)) {
        //all Numeric fields are valid and proceed to submit data
        this.okButtonDisabled = false;
        this.webConfigurationErrorMessage = "";
      } else {
        this.webConfigurationErrorMessage = "*Some fields are invalid!, Please do update them."
        this.okButtonDisabled = true;
      }
    },
    validateNumericInput() {
      if (!this.isNumeric(this.numericValue)) {
        this.numericValue = null;
        this.isConditionSatisfiedWeb()
      }
    },
    updateSelectedOtherWebSettingsChanges() {
      let settingsObject = {};
      if (this.changedWebSettingsControls.hasOwnProperty('hasQuestionnarieTemplete')) {
        settingsObject['hasQuestionnarieTemplete'] = this.hasQuestionnarieTemplete;
      }
      if (this.changedWebSettingsControls.hasOwnProperty('entranceActivityRefreshRateInSeconds')) {
        settingsObject['entranceActivityRefreshRateInSeconds'] = this.refreshRateInSeconds;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('enableCSVDownload')) {
        settingsObject['enableCSVDownload'] = this.editCSVDownload;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('punchInDataAvailable')) {
        settingsObject['punchInDataAvailable'] = this.punchInData;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('lowTemperatureCutoff')) {
        settingsObject['lowTemperatureCutoff'] = this.temperatureCutoff;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('employeeIdNotUnique')) {
        settingsObject['employeeIdNotUnique'] = this.employeeIdNotUnique;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('enableSchedule')) {
        settingsObject['enableSchedule'] = this.enableSchedule;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('useTenantSpecificRoles')) {
        settingsObject['useTenantSpecificRoles'] = this.useTenantSpecificRoles;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('hasQuestionnarieAddress')) {
        settingsObject['hasQuestionnarieAddress'] = this.hasQuestionnarieAddress;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('patientNameFormat')) {
        settingsObject['patientNameFormat'] = this.patientNameFormatSelectedOption;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('vm_maxViewMode')) {
        settingsObject['vm_maxViewMode'] = this.vm_maxViewMode;
      }
      if (this.changedWebSettingsControls.hasOwnProperty('vm_popupInterval')) {
        settingsObject['vm_popupInterval'] = this.vm_popupInterval * 60000;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('vm_popupCheckInterval')) {
        settingsObject['vm_popupCheckInterval'] = this.vm_popupCheckInterval * 60000;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('hideAllFacilities')) {
        settingsObject['hideAllFacilities'] = this.hideAllFacilities;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('enableTimerInEntranceActivity')) {
        settingsObject['enableTimerInEntranceActivity'] = this.enableTimerInEntranceActivity;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('disableNoiseSuppression')) {
        settingsObject['disableNoiseSuppression'] = this.disableNoiseSuppression;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('disableVirtualNursingChime')) {
        settingsObject['disableVirtualNursingChime'] = this.disableVirtualNursingChime;
      }

      if (this.changedWebSettingsControls.hasOwnProperty('endCallTimeout')) {
        settingsObject['endCallTimeout'] = this.endCallTimeout * 1000;
      }
      if (this.customHelpmessage != '') {
        settingsObject['customHelpMessage'] = this.customHelpmessage;
      }
      if (this.changedWebSettingsControls.hasOwnProperty('disablePTT')) {
        settingsObject['disablePTT'] = this.disablePTT;
      }
      if (this.changedWebSettingsControls.hasOwnProperty('preventPTTSS')) {
        settingsObject['preventPTTSS'] = this.preventPTTSS;
      }
      return settingsObject;
    },
    editModal() {

this.webConfigurationErrorMessage = '';
this.$bvModal.hide("webSettingsModal");
},
    }
}
</script>
<style scoped lang="scss">
  @import "../../style.scss";

  .modal-body {
    padding: 0px;
  }
  .card {
    border: 2px solid #e7e7e7;
    border-radius: 4px;
    padding: 0.5rem;
    background-color: #5d6d7e;
    color: #fff;
  }

  .checkbox-container {
    color: #6a6a6a;
    font-family: GTWalsheimPro-Regular;
  }

  .custom-form-label {
    color: #3288D2 !important;
    font-family: GTWalsheimPro-Regular !important;
    font-size: 16px;
    font-weight: 400;
  }

  .card-body {
    padding-bottom: 5px !important;
  }

  .card-container-panel {
    background-color: white;
    padding: 0;
    margin: 1rem 1rem 0 1rem;
  }

  h4 {
    color: #1a80a8;
  }

  .form-control::placeholder {
    color: #6c757d !important;
    opacity: 0.8;
  }

  .modal-body-container {
    max-height: 650px !important;
    overflow-y: auto;
    padding-bottom: 1rem;
  }
  ::v-deep #webSettingsModal .modal-body {
  padding: 0px;
}

::v-deep #webSettingsModal .modal-dialog {
  margin: 1.75rem auto;
}

::v-deep #webSettingsModal .modal-content {
  -webkit-box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
  -moz-box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
  box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
}
.in-valid {
  border-color: #dc1414 !important;
}

.valid {
  border-color: 1px solid #7a8991 !important;
}
.modal-body-container .errorMsgContainer{
  color: #dc1414;
  padding-left: 10px;
}
</style>